module.exports = __webpack_public_path__ + "static/img/texun333.7434fc2.png";